import { render, staticRenderFns } from "./career-story-detail.vue?vue&type=template&id=eb48fe20&scoped=true&"
import script from "./career-story-detail.vue?vue&type=script&lang=js&"
export * from "./career-story-detail.vue?vue&type=script&lang=js&"
import style0 from "./career-story-detail.vue?vue&type=style&index=0&id=eb48fe20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb48fe20",
  null
  
)

export default component.exports